import { useQuery } from '@tanstack/react-query';
import bookingApi from '@/features/public/booking/api/bookingApi.ts';
import { bookingApiQueryKeys } from '@/features/public/booking/api/bookingApi.queryKeys.ts';

const useGetTourConsents = (orgSlug: string, tourSlug: string) => {
  return useQuery({
    queryKey: bookingApiQueryKeys.tourConsents(orgSlug, tourSlug),
    queryFn: () => bookingApi.getTourConsents(orgSlug, tourSlug),
  });
};

export default useGetTourConsents;
